namespace ui
{
	export namespace paging
	{

		export interface PaginationDescriptor
		{
			sync?: number;
			size?: 'lg'|'sm';
			jumper?: boolean;
			center?: boolean;
		}

		export class Pagination
		{

			private	m_Root: JQuery;
			private m_List: JQuery[];
			private	m_CList: Function[];
			private	m_UL: JQuery;
			private	m_Desc: PaginationDescriptor;
			private m_Active: number;
			private m_Child?: Pagination | null;
			private m_Parent?: Pagination | null;
			private m_First?: JQuery;
			private m_Last?: JQuery;
			private m_Next?: JQuery;
			private m_Prev?: JQuery;

			public constructor( descriptor?: PaginationDescriptor )
			{
				this.m_Root		= ui.$$.nav();
				this.m_List		= new Array<JQuery<HTMLElement>>();
				this.m_CList	= new Array<Function>();
				this.m_UL			= ui.$$.ul();
				this.m_Desc		= descriptor || {};
				this.m_Active	= 0;
				this.m_Child	= null;
				this.m_Parent	= null;

				if ( descriptor )
				{
					if ( descriptor.sync && descriptor.sync > 0 )
					{
						const tmpDesc: PaginationDescriptor = JSON.parse( JSON.stringify( descriptor ) );

						tmpDesc.sync = descriptor.sync - 1;

						this.m_Child = new Pagination( tmpDesc );
						this.m_Child.m_Parent = this;
					}

					if ( descriptor.jumper )
					{
						this.m_First = ui.$$.li().append( ui.$$.span().addClass( 'fas fa-angle-double-left' ) ).appendTo( this.m_UL );
						this.m_First.css( 'cursor', 'pointer' );

						this.m_Prev = ui.$$.li().append( ui.$$.span().addClass( 'fas fa-angle-left' ) ).appendTo( this.m_UL );
						this.m_Prev.css( 'cursor', 'pointer' );

						this.m_Next = ui.$$.li().append( ui.$$.span().addClass( 'fas fa-angle-right' ) ).appendTo( this.m_UL );
						this.m_Next.css( 'cursor', 'pointer' );

						this.m_Last = ui.$$.li().append( ui.$$.span().addClass( 'fas fa-angle-double-right' ) ).appendTo( this.m_UL );
						this.m_Last.css( 'cursor', 'pointer' );
					}
				}

				this.m_UL.appendTo( this.m_Root );
			}

			public Count(): number
			{
				return this.m_List.length;
			}

			public Active(): number
			{
				return this.m_Active;
			}

			public SetActive( idx: number )
			{
				if ( this.m_First )	{ this.m_First.removeClass(); }
				if ( this.m_Prev )	{ this.m_Prev.removeClass(); }
				if ( this.m_Next )	{ this.m_Next.removeClass(); }
				if ( this.m_Last )	{ this.m_Last.removeClass(); }

				if ( idx <= 0 )
				{
					idx = 0;

					if ( this.m_First )
					{
						this.m_First.addClass( 'disabled' );
					}

					if ( this.m_Prev )
					{
						this.m_Prev.addClass( 'disabled' );
					}
				}

				if ( idx >= this.m_List.length - 1 )
				{
					idx = this.m_List.length - 1;

					if ( this.m_Next )
					{
						this.m_Next.addClass( 'disabled' );
					}

					if ( this.m_Last )
					{
						this.m_Last.addClass( 'disabled' );
					}
				}

				for ( const i in this.m_List )
				{
					const item = this.m_List[ i ];

					item.removeClass();

					if ( parseInt( i ) == idx )
					{
						item.addClass( 'active' );
					}
				}

				this.m_Active = idx;
				if ( this.m_Parent && this.m_Parent.m_Active != idx ) { this.m_Parent.SetActive( idx ); }
				if ( this.m_Child && this.m_Child.m_Active != idx )	{ this.m_Child.SetActive( idx ); }
			}

			public rebuild(): void
			{
				this.m_Root.removeAttr( 'aria-label' );
				this.m_Root.removeClass();
				this.m_Root.attr( 'aria-label', 'Page' );

				if ( this.m_Desc.center )
				{
					this.m_Root.addClass( 'text-center' );
				}

				this.m_UL.empty();
				this.m_UL.removeClass();
				this.m_UL.addClass( 'pagination' );

				if ( this.m_Desc.size )
				{
					this.m_UL.addClass( 'pagination-' + this.m_Desc.size );
				}

				if ( this.m_First )
				{
					this.m_UL.append( this.m_First );

					this.m_First.on( 'click', () => { if ( this.m_First && !this.m_First.hasClass( 'disabled' ) ) { this.m_CList[ 0 ](); } } );
					this.m_First.on( 'click', () => { if ( this.m_First && !this.m_First.hasClass( 'disabled' ) ) { this.SetActive( 0 ); } } );

					if ( 0 == this.m_Active )
					{
						this.m_First.addClass( 'disabled' );
					}
				}

				if ( this.m_Prev )
				{
					this.m_UL.append( this.m_Prev );

					this.m_Prev.on( 'click', () => { if ( this.m_Prev && !this.m_Prev.hasClass( 'disabled' ) ) { this.m_CList[ clamp( this.m_Active - 1, 0, this.m_List.length - 1 ) ](); } } );
					this.m_Prev.on( 'click', () => { if ( this.m_Prev && !this.m_Prev.hasClass( 'disabled' ) ) { this.SetActive( clamp( this.m_Active - 1, 0, this.m_List.length - 1 ) ); } } );

					if ( 0 == this.m_Active )
					{
						this.m_Prev.addClass( 'disabled' );
					}
				}

				for ( const i in this.m_List )
				{
					const item = this.m_List[ i ];

					if ( parseInt( i ) == this.m_Active )
					{
						item.addClass( 'active' );
					}

					item.appendTo( this.m_UL );

					const idx = parseInt( i );

					item.on( 'click', () => { if ( this.m_Active != idx ) { this.m_CList[ idx ].call( item ); } } );
					item.on( 'click', () => { if ( this.m_Active != idx ) { this.SetActive( idx ); } } );
				}

				if ( this.m_Next )
				{
					this.m_UL.append( this.m_Next );

					this.m_Next.on( 'click', () => { if ( this.m_Next && !this.m_Next.hasClass( 'disabled' ) ) { this.m_CList[ clamp( this.m_Active + 1, 0, this.m_List.length - 1 ) ](); } } );
					this.m_Next.on( 'click', () => { if ( this.m_Next && !this.m_Next.hasClass( 'disabled' ) ) { this.SetActive( clamp( this.m_Active + 1, 0, this.m_List.length - 1 ) ); } } );

					if ( this.m_List.length - 1 == this.m_Active )
					{
						this.m_Next.addClass( 'disabled' );
					}
				}

				if ( this.m_Last )
				{
					this.m_UL.append( this.m_Last );

					this.m_Last.on( 'click', () => { if ( this.m_Last && !this.m_Last.hasClass( 'disabled' ) ) { this.m_CList[ this.m_List.length - 1 ](); } } );
					this.m_Last.on( 'click', () => { if ( this.m_Last && !this.m_Last.hasClass( 'disabled' ) ) { this.SetActive( this.m_List.length - 1 ); } } );

					if ( this.m_List.length - 1 == this.m_Active )
					{
						this.m_Last.addClass( 'disabled' );
					}
				}

				if ( this.m_Child )
				{
					this.m_Child.rebuild();
				}
			}

			public Clear(): void
			{
				this.m_List = [];
				this.m_CList = [];

				if ( this.m_Child )
				{
					this.m_Child.Clear();
				}
			}

			public AddItem( text: string|JQuery<HTMLElement>|HTMLElement, onClick: Function, idx?: number )
			{
				if ( this.m_Child )
				{
					this.m_Child.AddItem( text, onClick, idx );
				}

				const item	= ui.$$.li();

				item.append( ui.$$.span().append( text ) );
				item.css( 'cursor', 'pointer' );

				if ( idx === undefined )
				{
					this.m_List.push( item );
					this.m_CList.push( onClick );

					return;
				}

				this.m_List.splice( idx, 0, item );
				this.m_CList.splice( idx, 0, onClick );
			}

			public Root( what: number = 0 ): JQuery<HTMLElement>
			{
				if ( what > 0 && this.m_Child )
				{
					return this.m_Child.Root( what - 1 );
				}

				return this.m_Root;
			}

		}

	}
}
